import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { PeppolAPTestbedValidationTestFileHelperContainerModel } from '../../../../../../models/aggregates/e-invoice/peppol/bl_ppl_ap_validation_test_file_zip_helper.model';

@Injectable({
  providedIn: 'root'
})
export class PeppolAPTestbedValidationTestFileHelperService extends BaseApiTemplateService<PeppolAPTestbedValidationTestFileHelperContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'ppl/ap/validation-test-file-helper/backoffice-ep'

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'ppl/ap/validation-test-file-helper/backoffice-ep'
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'ppl/ap/validation-test-file-helper/backoffice-ep'
    this.httpClient = http;
  }
}
